export default __webpack_public_path__ + "static/media/sounds/ES_TRO_Remember_Read_Outloud.mp3";